import type { IBuildingOffersState } from 'shared/types/buildingOffers';
import type { TApplicationState } from 'shared/types/redux';

export const selectBuildingOffers = (state: TApplicationState): IBuildingOffersState => state.buildingOffers;
